import { useLocation, useNavigate } from 'react-router-dom';
import SubjectHeader from '../../../components/SubjectHeader/SubjectHeader';
import './CommonChatList.scss';
import CommonSearch from '../../../components/Search/CommonSearch';
import { FC, useCallback, useState } from 'react';
import CommonChatPersonCard from './CommonChatPersonCard';
import { ChatdataType, ChatListType, DefaultUserList, DefaultUserType, SearchUserType, UserList } from '../CommonChats';
import { debounce } from 'lodash';
import { useLazyQuery, useMutation } from '@apollo/client';
import { ADD_INDIVIDUAL_CHAT, GET_ALL_CHAT_LIST, SEARCH_CHAT_LIST } from '../api/ChatsQuery';
import ToasterWithMessage from '../../../components/toaster';
import { useAppSelector } from '../../../redux/app/hooks';
import { FETCH_POLICY_NO_CACHE, PATH_ADDRESSES, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR } from '../../../utils/constants';
import { CircularProgress } from '@mui/material';
import { getScreenDimensions } from '../../../utils/helper';

interface PropsType {
  chatList?: DefaultUserList | undefined
  setSelectedChat?: any,
  selectedChat?: DefaultUserType | undefined,
  setSelectedGroupChat?: any,
  selectedGroupChat?: ChatListType | undefined,
  setSelectedSearchChat?: any,
  selectedSearchChat?: SearchUserType | undefined,
  socketRef: any,
  chatGroupList: ChatListType[] | undefined,
  setRefetch: any,
  setChatList: any,
  setType: any,
  type:string,
  setChatMessages:any,
  setChatLoading:any,
  chatLoading:boolean,
  chatMessages : ChatdataType | undefined,
  setIsSidebarOpen: (val: boolean) => void;
  isSidebarOpen: boolean;
  isChime: boolean;
}
const CommonChatList: FC<PropsType> = ({ 
  setSelectedChat, 
  selectedChat, 
  setSelectedGroupChat, 
  selectedGroupChat, 
  setSelectedSearchChat, 
  selectedSearchChat, 
  chatList, 
  chatGroupList, 
  setRefetch, 
  setChatList , 
  setType, 
  setIsSidebarOpen, 
  isChime
}) => {
  const { state:locationState } = useLocation();
  const [searchValue, setSearchValue] = useState<string>('');
  const [searchChatList, setSearchChatList] = useState<UserList>();
  const { error } = ToasterWithMessage();
  const role = useAppSelector((state) => state.auth.role);
  const navigate = useNavigate();
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const [selectedRooomId,setSelectedRooomId] = useState();
  const {isMobileScreen} = getScreenDimensions();

  const [getSearchChatList, { loading: searchChatLoading }] = useLazyQuery(SEARCH_CHAT_LIST, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setSearchChatList(data?.allUsers);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });

  const [getChatList, { loading:chatListLoading }] = useLazyQuery(GET_ALL_CHAT_LIST, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setSearchValue('');
      setChatList(data?.getIndividualChatList);
      console.log("[Debug] Chat list fetched:", data?.getIndividualChatList);
      console.log("[Debug] Selected Room ID:", selectedRooomId);
      // Check if any chatRoomId matches the selectedRoomId
      const matchingChat = data?.getIndividualChatList?.nodes?.find(
          (chat:DefaultUserType) => (isChime ? chat?.chimeChannelArn : chat.chatroomId) === selectedRooomId
      );
    
    console.log("[Debug] Matching chat found:", matchingChat);
    if (matchingChat) {
      setSelectedChat(matchingChat);
      setIsSidebarOpen(false);
    } else {
      console.log('nomatching chat found');
    }
    },
    onError: (err) => {
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });

  const [addSearchChatList, { loading: addChatLoading }] = useMutation(ADD_INDIVIDUAL_CHAT, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setSelectedSearchChat(data?.insertIndividualChatList);
      setSelectedRooomId(data?.insertIndividualChatList)
      setSelectedGroupChat(undefined);
      setSelectedChat(undefined);
      setRefetch(true);
      setIsSidebarOpen(false);
      getChatList({
        variables:{
          input:{
            cId:selectedClassRoomId,
            sjId:selectedSubjectId,
            messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET',
            // uId:profile?.getCurrentUser?.nodes?.[0]?.uId,
            limit:null,
            offset:null
          }
        }
      });
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });

  const handleSearchDebounce = useCallback(
    debounce((value) => {
      setSearchValue(value);
      if(value?.trim() !== "" && value?.trim().length >= 3){
        getSearchChatList({
          variables: {
            cId: selectedClassRoomId,
            input: `%${value.trim()}%`,
            limit: null,
            offset: null,
            uId:profile?.getCurrentUser?.nodes?.[0]?.uId, 
            sjId:   selectedSubjectId    
           }
        });
      }
    }, 500),
    [getSearchChatList]
  );


  const handleGroupChatClick = async (chat: ChatListType) => {
    console.log('inside the handleGroupChatClick');
    setSelectedGroupChat(chat);
    setSelectedChat(undefined);
    setSelectedSearchChat(undefined);
    setType("group");
    setIsSidebarOpen(false);
  };

  const handleChatClick = async (chat: DefaultUserType) => {
    console.log('inside the handleChatClick')
    if((isChime ? chat?.chimeChannelArn : chat.chatroomId) !== (isChime ? selectedChat?.chimeChannelArn : selectedChat?.chatroomId)){
      setType('');
      setSelectedGroupChat(undefined);
      setSelectedSearchChat(undefined);
      setSelectedChat(chat);
      setIsSidebarOpen(false);
    }
  };

  const handleSearchChatClick = async (chat: SearchUserType) => {
    setSelectedSearchChat(chat);
    console.log('inside the handleSearchChatClick')
    setType('');
    setIsSidebarOpen(false);
    addSearchChatList({
      variables:{
        input:{
          cId: selectedClassRoomId,
          sjId:selectedSubjectId,
          uId:chat?.uId,
          fullname:chat?.uFullName,
          messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET',
        }
      }
    })
  };
  
  return (
    <div className='commonChatListMainContainer'>
      <SubjectHeader
        backgroundColor={locationState?.backGroundColor}
        headerName={locationState?.title}
        headerImage={locationState?.imageSrc}
        backNavigation={{ path: role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH, state: locationState }}
        handleSearchDebounce={handleSearchDebounce}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      <div className='searchAndChatPersonsListMainContainer'>
        {!isMobileScreen && <CommonSearch
          handleSearchDebounce={handleSearchDebounce}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          from={`CommonChat`}
        />}
        <div className='chatPersonsListContainer'>
          {chatGroupList?.map((chat: ChatListType) => (
            <CommonChatPersonCard groupChatData={chat} selectedGroupChat={selectedGroupChat} onClick={() => handleGroupChatClick(chat)} type={"group"} />
          ))
          }
          { 
            (addChatLoading || searchChatLoading || chatListLoading) ? 
            <div className='listLoder'>
             <CircularProgress />
             </div>
            :
            (searchChatList && searchValue) ?
            searchChatList?.nodes?.map((chat: SearchUserType) => (
              <CommonChatPersonCard searchChatData={chat} selectedSearchChat={selectedSearchChat} onClick={() => handleSearchChatClick(chat)} type={"search"} />
            )):(
              chatList?.nodes?.map((chat: DefaultUserType) => (
                <CommonChatPersonCard chatData={chat} selectedChat={selectedChat} onClick={() => handleChatClick(chat)} type={"defaultUser"} />
              ))
            )
          }
          </div>
      </div>
    </div>
  )
}

export default CommonChatList;
